import React from 'react'
import Navbar from './Navbar'
import Comments from './Comments'
import Footer from './Footer'
import { HomeFinder, HomeCategories, HomeFeatures, HowItWorks } from './HomeHero'

// Bosh sahifa. Renthome/CoLiving o'rniga "Tavsiya etilgan e'lonlar" karuseli (HomeFeatured).
export default function Components() {
  return (
    <div className='big_box hm'>
        <Navbar/>
        <main>
          {/* E'lonlar birinchi ekranda: qidiruv kartasi filtrlari pastdagi e'lonlarni darhol o'zgartiradi */}
          <HomeFinder/>
          <HomeCategories/>
          <HomeFeatures/>
          <HowItWorks/>
          <Comments/>
        </main>
        <Footer/>
    </div>
  )
}
